import { render, staticRenderFns } from "./DialogAboutAge.vue?vue&type=template&id=0b38e7db&"
import script from "./DialogAboutAge.vue?vue&type=script&lang=js&"
export * from "./DialogAboutAge.vue?vue&type=script&lang=js&"
import style0 from "./DialogAboutAge.vue?vue&type=style&index=0&id=0b38e7db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports